// extracted by mini-css-extract-plugin
export default {"pageWrap":"rb-z","fullWidth":"sb-z","heading":"tb-z","fullBleed":"ub-z","hidden":"vb-z"};